<template>
  <div class="fixed top-0 left-0 w-screen h-full bg-white">
    <page class="h-full">
      <template #leftBtn>
        <img
          src="../../../assets/common/back-icon.svg"
          alt="back"
          @click="$emit('update:show-reset-password', false)"
        />
      </template>
      <template #rightBtn>
        <img
          src="../../../assets/common/close-icon.svg"
          alt="menu"
          @click="$emit('clear-active-page')"
        />
      </template>
      <template #content>
        <div class="text-xl" v-html="$t('login.set_up_new_password')"></div>
        <div
          class="input-wrapper relative mb-4 rounded-sm"
          :class="{ focus: focusStatus === 'password' }"
        >
          <input
            class="w-full h-12 pl-6 outline-none"
            :type="isHide.firstInput ? 'password' : 'text'"
            v-model="password"
            autofocus
            :placeholder="$t('login.enter_password')"
            @click="focusStatus = 'password'"
          />
          <img
            v-if="isHide.firstInput"
            class="eye-icon absolute"
            src="../../../assets/common/eye.svg"
            @click="isHide.firstInput = !isHide.firstInput"
          />
          <img
            v-else
            class="eye-icon absolute"
            src="../../../assets/common/black-eye.svg"
            @click="isHide.firstInput = !isHide.firstInput"
          />
        </div>
        <div
          class="input-wrapper relative rounded-sm"
          :class="{ focus: focusStatus === 'confirmPassword' }"
        >
          <input
            class="w-full h-12 pl-6 outline-none"
            :type="isHide.secondInput ? 'password' : 'text'"
            v-model="confirmPassword"
            :placeholder="$t('login.re_enter_password')"
            @click="focusStatus = 'confirmPassword'"
          />
          <img
            v-if="isHide.secondInput"
            class="eye-icon absolute"
            src="../../../assets/common/eye.svg"
            @click="isHide.secondInput = !isHide.secondInput"
          />
          <img
            v-else
            class="eye-icon absolute"
            src="../../../assets/common/black-eye.svg"
            @click="isHide.secondInput = !isHide.secondInput"
          />
        </div>
        <c-button :confirmed-status="confirmedStatus" class="relative mt-12" @click="send">
          <span>{{ $t('login.set_new_pwd') }}</span>
        </c-button>
        <error-message v-if="errorMsg" :message="errorMsg" />
      </template>
    </page>
  </div>
</template>

<script>
import loginError from '@/mixins/login-error';
import Page from '@/components/common/Page.vue';
import CButton from '@/components/common/CButton.vue';
import ErrorMessage from '../common/ErrorMessage.vue';

export default {
  mixins: [loginError],
  components: {
    Page,
    CButton,
    ErrorMessage,
  },
  props: {
    phoneNumber: String,
    token: String,
  },
  data() {
    return {
      password: '',
      confirmPassword: '',
      isHide: { firstInput: true, secondInput: true },
      errorMsg: null,
      focusStatus: 'password',
    };
  },
  computed: {
    confirmedStatus() {
      return this.password.length > 3 && this.password === this.confirmPassword;
    },
  },
  methods: {
    async send() {
      if (!this.confirmedStatus) return;
      this.$events.startLoading();
      const req = {
        username: this.phoneNumber,
        password: this.password,
        confirm_token: this.token,
        provider: 0,
      };

      try {
        await this.$api.user.put('/api/v1/users/password', req);
        this.$emit('set-reset-page');
      } catch (e) {
        this.errorMsg = this.handleLoginError(e);
      }
      this.$events.stopLoading();
    },
  },
};
</script>

<style lang="scss" scoped>
.input-wrapper {
  width: 309px;
  @apply bg-no-repeat;
  @apply bg-contain;
  background-color: #f5f5f5;

  &.focus {
    @apply bg-white;
    background-image: url('../../../assets/common/rectangle-1334.svg');
  }

  input {
    width: 80%;
    background: none;
  }
}

.forget-text {
  width: 309px;
}

.eye-icon {
  top: 50%;
  right: 21px;
  transform: translateY(-50%);
}
</style>
